import { Component, HostListener, OnInit, ViewChild, ElementRef }  from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { Title }                    from '@angular/platform-browser';
import { Router }                   from '@angular/router';

@Component({
  selector: 'my-home',
  template: require('./home.component.html'),
  styles: [require('./home.component.scss')]
})
export class HomeComponent implements OnInit {
  splitWidth: number;
  inverseWidth: number = window.innerWidth / 2;
  windowWidth: number = window.innerWidth;
  windowHeight: number = window.innerHeight;
  @ViewChild('art') art: ElementRef;
  artPaddingLeft  = 0;
  artPaddingRight = 0;
  artOpacity      = 1;
  @ViewChild('work') work: ElementRef;
  workPaddingLeft   = 0;
  workPaddingRight  = 0;
  workOpacity       = 1;

  constructor(private routerService: Router, private titleService: Title) {
    this.titleService.setTitle('Francis Li');
  }

  ngOnInit() {
    this.calculateSplitWidth();
    this.inverseWidth = this.splitWidth;
  }

  calculateSplitWidth() {
    let element = this.art.nativeElement;
    let left = element.offsetWidth;
    do {
      left += element.offsetLeft;
      element = element.offsetParent;
    } while (element);
    this.splitWidth = left;
  }

  @HostListener('window:resize')
  onResize() {
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.calculateSplitWidth();
    this.inverseWidth = this.splitWidth;
  }

  onArtClick() {
    this.inverseWidth = window.innerWidth;
    this.workOpacity = 0;
    this.artPaddingLeft = this.work.nativeElement.offsetWidth;
    this.artPaddingRight = 0;
    setTimeout(() => {
      this.routerService.navigate(['/art']);
    }, 250);
  }

  onArtEnter() {
    this.inverseWidth = this.splitWidth + 100;
    this.artPaddingLeft = this.artPaddingRight = 100;
  }

  onArtLeave() {
    this.inverseWidth = this.splitWidth;
    this.artPaddingLeft = this.artPaddingRight = 0;
  }

  onWorkClick() {
    this.inverseWidth = 0;
    this.artOpacity = 0;
    this.workPaddingRight = this.art.nativeElement.offsetWidth;
    this.workPaddingLeft = 0;
    setTimeout(() => {
      this.routerService.navigate(['/work']);
    }, 250);
  }

  onWorkEnter() {
    this.inverseWidth = this.splitWidth - 100;
    this.workPaddingLeft = this.workPaddingRight = 100;
  }

  onWorkLeave() {
    this.inverseWidth = this.splitWidth;
    this.workPaddingLeft = this.workPaddingRight = 0;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/home/home.component.ts